export default __webpack_public_path__ + "css/userinvite.module.css";